
import ReceiptEdit from "../../../assets/duotone/ReceiptEdit.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ReceiptEditIcon({ className, dataTestid = "ReceiptEditIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ReceiptEdit data-testid={dataTestid} className={classes} {...rest} />
  );
}
